module.exports = __webpack_public_path__ + "img/credential.a67e4840.png";